import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Client from './client'
import loglevel from 'loglevel'
import packageJson from '../package.json'

const { name: APP_NAME, version: APP_VERSION } = packageJson

if ('sendBeacon' in navigator) {
  navigator.sendBeacon(
    'https://api.apps.austauschkompass.de/' + APP_NAME + '/track',
    JSON.stringify({ version: APP_VERSION, url: document.location.href })
  )
}

let log = loglevel.noConflict()
const hRoot = document.getElementById('sch-awards-widget')
const vRoot = document.getElementById('sch-awards-widget-portrait')
const client = new Client(process.env.REACT_APP_API_HOST)
const organisation = ((hRoot && hRoot.dataset.organisation) || (vRoot && vRoot.dataset.organisation))

if (organisation) {
  client.get('awards', { organisation_slug: organisation })
    .then(res => {
      if (res.errors) {
        log.warn(res.errors)
      }
      else {
        if (hRoot) {
          ReactDOM.render(<App awards={res.data}
                               name={res.meta.organisation.shortname}
                               slug={organisation}
                               orientation='landscape' />, hRoot);
        }
        if (vRoot) {
          ReactDOM.render(<App awards={res.data}
                               name={res.meta.organisation.shortname}
                               slug={organisation}
                               orientation='portrait' />, vRoot);
        }
      }
    }).catch((e) => {
      log.warn(e)
    })
}
